import { usePermissions, useGetIdentity } from 'react-admin';
import { hasPermission } from '../../utils/hasPermission';
import { isPlatformActor } from '../RequirePermission';

export const useCanWritePolicies = (): boolean => {
    const { permissions } = usePermissions();
    const { identity } = useGetIdentity();
    const list = permissions as string[] | null | undefined;
    const vendorIds: string[] = ((identity as any)?.vendorIds as string[]) || [];
    return hasPermission(list, 'reservation-policies:write:all') && isPlatformActor(list, vendorIds);
};
